/**
 * API returns same-origin `/api/...` media paths (Vite proxy / admin nginx).
 * Coolify admin is static-only — rewrite to `VITE_API_URL` (API has no `/api` prefix).
 */
export function resolveApiMediaUrl(url: string | null | undefined): string | null {
  if (url == null) return null;
  const trimmed = String(url).trim();
  if (!trimmed) return null;
  if (/^(https?:|data:|blob:)/i.test(trimmed)) return trimmed;
  const base = String(import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');
  if (!base || base.startsWith('/')) return trimmed;
  const path = trimmed.startsWith('/api/')
    ? trimmed.slice(4)
    : trimmed.startsWith('/')
      ? trimmed
      : `/${trimmed}`;
  return `${base}${path}`;
}
